var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-company-edit-wrapper",
    { attrs: { company: _vm.company, "no-scroll": "" } },
    [
      _c(
        "w-row",
        { attrs: { grow: "" } },
        [
          _vm.state
            ? _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [_vm._v("Emails")]),
                      _c(
                        "w-card-content",
                        [
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c(
                                    "w-row",
                                    { attrs: { "no-margin": "" } },
                                    [
                                      _c("span", { staticClass: "bold" }, [
                                        _vm._v(" Service Pack herinnering: "),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.spExpirationStateText) +
                                          " "
                                      ),
                                      _c("w-spacer"),
                                      _c(
                                        "w-dropdown",
                                        {
                                          attrs: {
                                            items: _vm.spExpirationActions,
                                            flat: "",
                                            right: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handle($event)
                                            },
                                          },
                                        },
                                        [
                                          _c("w-fa", {
                                            attrs: { icon: "ellipsis-v" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }